import { useEffect, useState } from "react"
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const MobilitiesRecords = ({
    patientDBdata,
    diagnosisName,
    setPatientDBdata,
    noteID,
    isHavingMobilityAssessment,
    setIsHavingMobilityAssessment
}) => {

    if(diagnosisName && diagnosisName !== 'Falls') {
        return null
    }
    const [mobilityAssessment, setMobilityAssessment] = useState('')
    // const [isHavingMobilityAssessment, setIsHavingMobilityAssessment] = useState(false)

    // Define fields for mobility assessment questions
    const questionFields = [
        { key: 'rollLeftAndRight', label: 'Roll left and right' },
        { key: 'sitToLying', label: 'Sit to lying' },
        { key: 'lyingToSittingOnSideOfBed', label: 'Lying to sitting on side of bed' },
        { key: 'sitToStand', label: 'Sit to stand' },
        { key: 'chairToBedTransfer', label: 'Chair to bed transfer' },
        { key: 'toiletTransfer', label: 'Toilet transfer' },
        { key: 'walk10Feet', label: 'Walk 10 feet' },
        { key: 'ambulatoryAids', label: 'Ambulatory aids' },
    ]

    // Fetch the saved data and set it into state
    useEffect(() => {
        if (!diagnosisName) return

        const savedHtml = null || patientDBdata?.currentNote?.data?.freeTypesEverything?.MobilityAssessment?.[diagnosisName]
        const mobilityData = patientDBdata?.currentNote?.data?.MobilityAssessment?.assessment

        if (mobilityData) {
            setMobilityAssessment(savedHtml ? savedHtml : `
      <div>
        ${questionFields.map((field) => {
                const values = mobilityData?.[field.key]
                console.log(values, 'values')
                if (!Array.isArray(values) || values.length === 0) return ''
                return `
            <div key="${field.key}" style="margin-bottom: 6px;">
              <strong>${field.label}:</strong> ${values.map((item) => item.label).join(', ')}
            </div>
          `
            }).join('')}
      </div>

    `
            )

            if (!savedHtml) {
                setPatientDBdata((prev) => ({
                    ...prev,
                    currentNote: {
                        ...prev?.currentNote,
                        data: {
                            ...prev?.currentNote?.data,
                            freeTypesEverything: {
                                ...(prev?.currentNote?.data?.freeTypesEverything || {}),
                                MobilityAssessment: {
                                    ...(prev?.currentNote?.data?.freeTypesEverything?.MobilityAssessment || {}),
                                    [diagnosisName]: `
      <div>
        ${questionFields.map((field) => {
                                        const values = mobilityData?.[field.key]
                                        console.log(values, 'values')
                                        if (!Array.isArray(values) || values.length === 0) return ''
                                        return `
            <div key="${field.key}" style="margin-bottom: 6px;">
              <strong>${field.label}:</strong> ${values.map((item) => item.label).join(', ')}
            </div>
          `
                                    }).join('')}
      </div>

    `
                                },
                            },
                        },
                    },
                    allNotes: prev?.allNotes?.map((note) => {
                        if (note?.id === noteID) {
                            const parsedData = note?.data ? JSON.parse(note.data) : {}
                            return {
                                ...note,
                                data: JSON.stringify({
                                    ...parsedData,
                                    freeTypesEverything: {
                                        ...(parsedData?.freeTypesEverything || {}),
                                        MobilityAssessment: {
                                            ...(parsedData?.freeTypesEverything?.MobilityAssessment || {}),
                                            [diagnosisName]: `
      <div>
        ${questionFields.map((field) => {
                                                const values = mobilityData?.[field.key]
                                                console.log(values, 'values')
                                                if (!Array.isArray(values) || values.length === 0) return ''
                                                return `
            <div key="${field.key}" style="margin-bottom: 6px;">
              <strong>${field.label}:</strong> ${values.map((item) => item.label).join(', ')}
            </div>
          `
                                            }).join('')}
      </div>

    `
                                        },
                                    },
                                }),
                            }
                        }
                        return note
                    }),
                }))
            }
            setIsHavingMobilityAssessment(true)

        } else {
            setIsHavingMobilityAssessment(false)
        }
    }, [patientDBdata, diagnosisName])

    const handleBlur = () => {
        if (!mobilityAssessment.trim()) return

        setPatientDBdata((prev) => ({
            ...prev,
            currentNote: {
                ...prev?.currentNote,
                data: {
                    ...prev?.currentNote?.data,
                    freeTypesEverything: {
                        ...(prev?.currentNote?.data?.freeTypesEverything || {}),
                        MobilityAssessment: {
                            ...(prev?.currentNote?.data?.freeTypesEverything?.MobilityAssessment || {}),
                            [diagnosisName]: mobilityAssessment,
                        },
                    },
                },
            },
            allNotes: prev?.allNotes?.map((note) => {
                if (note?.id === noteID) {
                    const parsedData = note?.data ? JSON.parse(note.data) : {}
                    return {
                        ...note,
                        data: JSON.stringify({
                            ...parsedData,
                            freeTypesEverything: {
                                ...(parsedData?.freeTypesEverything || {}),
                                MobilityAssessment: {
                                    ...(parsedData?.freeTypesEverything?.MobilityAssessment || {}),
                                    [diagnosisName]: mobilityAssessment,
                                },
                            },
                        }),
                    }
                }
                return note
            }),
        }))
    }

    if (diagnosisName !== 'Falls') {
        return null
    }

    if (!isHavingMobilityAssessment) {
        return null
    }


    return (
        <div className="w-100 my-4">
            <div style={{ width: '30%' }}>Mobility Assessment</div>
            <Editor
                value={mobilityAssessment}
                onChange={(e) => setMobilityAssessment(e.target.value)} // Update state when the user types
                onBlur={handleBlur} // Save the data when the user exits the editor
                containerProps={{
                    style: {
                        width: '100%',
                        background: '#2D2D2D',
                        color: 'white',
                        border: 0,
                    },
                }}
            >
                <Toolbar hidden />
            </Editor>
        </div>
    )
}

export default MobilitiesRecords
